<script lang="ts">
	import { FrontPageSections } from '@comp/section';
	let { data } = $props();
</script>

<!-- BUG: -->
<!-- When changing page the page reference changes to the next page -->
<!-- This almost has to be a bug in svelte5/sveltekit while in beta -->
<!-- Add a `$inspect(data);` in the script tag above and see the state change, as you change page -->
<!-- So here we have to chech if the data.page exists -->
<!-- We should be abli to remove this check in the future -->
<div class="frontpage">
	{#if data.page?.modules}
		<FrontPageSections blocks={data.page.modules} caller={data.pathname} />
	{/if}
</div>

<style lang="scss">
	.frontpage {
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}
</style>
